import Vue from 'vue'
import VeeValidate from 'vee-validate'

const config = {
  locale: 'tc',
  events: 'input',
  dictionary: {
    en: {
      messages: {
        required: (field) => field + ' should not be empty.',
        min: (field, args) => field + ' should be more than ' + args + ' alphamunerics.',
        max: (field, args) => field + ' should be less than ' + args + ' alphamunerics.',
        digits: (field, args) => field + ' should be ' + args + ' digit',
        min_value: (field, args) => field + ' should be more than ' + args,
        max_value: (field, args) => field + ' should be less than ' + args,
        integer: (field) => field + ' should be integer',
        mimes: (field, args) => field + ' should be mime ' + args,
        ext: (field, args) => field + ' should be extension ' + args,
        dimensions: (field, args) => field + ' should be ' + args,
        regex: (field) => 'The ' + field + ' is incorrect.',
        url: (field) => 'The ' + field + ' is incorrect.',
        email: () => 'Please enter right email format.',
        confirmed: () => 'Password confirmation is incorrect.',
        youtubeLink: (field) => field + ' is not youtube link'
      },
      attributes: {
      }
    },
    tc: {
      messages: {
        required: (field) => field + ' 欄位必填',
        min: (field, args) => field + ' 最少 ' + args + ' 個字',
        max: (field, args) => field + ' 不得超過 ' + args + ' 個字',
        digits: (field, args) => field + ' 請輸入 ' + args + ' 位數字',
        min_value: (field, args) => field + ' 不得低於 ' + args,
        max_value: (field, args) => field + ' 不得超過 ' + args,
        integer: (field) => field + ' 必須為整數',
        mimes: (field, args) => field + ' 必須符合MIME類型 ' + args,
        ext: (field, args) => field + ' 必須符合檔案類型 ' + args,
        dimensions: (field, args) => field + ' 寬與高須分別為 ' + args,
        regex: (field) => '無效的 ' + field,
        url: (field) => '無效的 ' + field,
        email: (field) => field + ' 請輸入正確Email格式',
        confirmed: () => '密碼不相符',
        youtubeLink: (field) => field + ' 不是youtube內嵌影片連結格式'
      },
      attributes: {
      }
    }
  }
}

Vue.use(VeeValidate, config)



// WEBPACK FOOTER //
// ./src/plugins/validation.js